import React from 'react';
import { Box, Flex, Text } from 'rebass';
import styled from 'styled-components';
import FullLayout2 from '../../../components/FullLayout';
import Header from '../../asyncIntake/Header';
import { useState } from 'react';
import { LearnMoreModal } from '../../asyncIntake/screens/LearnMoreModal';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import withSession from '../../../lib/withSession';
import { useEffect } from 'react';

const SuperContainer = styled(Flex)`
  width: 100vw;
  justify-content: center;
  z-index: 1;
  overflow-y: auto;
  flex: 1;
`;

const Container = styled(Flex)`
  max-width: 420px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  margin-top: 80px;
  z-index: 1;
  position: relative;
  overflow-y: none;
  margin-bottom: 36px;
  flex-direction: column;
`;
const ButtonWith = ({ price, duration, description, isMostPopular, onClick }) => {
  return (
    <Flex
      mb={3}
      style={{
        borderRadius: '10px',
        border: '1px solid #D0D2D5',
        cursor: 'pointer',
        padding: '12px 18px 12px 22px',
        gap: '12px',
        alignItems: 'center',
      }}
      onClick={onClick}
    >
      <Flex flex={1} flexDirection={'column'}>
        <Text style={{ fontSize: '14px', fontWeight: 400 }}>
          {`${duration} months - $${price}`}
          <span style={{ fontSize: '11px', fontWeight: 400 }}>/month</span>
        </Text>
        <Text style={{ fontSize: '10px', fontWeight: 400, opacity: 0.68 }}>{description}</Text>
      </Flex>
      {isMostPopular && (
        <Box
          style={{
            borderRadius: '5px',
            background: '#E7F0FF',
            height: 'fit-content',
            padding: '0 8px',
          }}
        >
          <Text style={{ lineHeight: '25px', fontWeight: 600, fontSize: '11px' }}>MOST POPULAR</Text>
        </Box>
      )}
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
        <path
          d="M0.365983 0.365983C0.131644 0.600393 0 0.918278 0 1.24973C0 1.58119 0.131644 1.89907 0.365983 2.13348L6.55348 8.32098L0.365983 14.5085C0.138286 14.7442 0.0122922 15.06 0.0151402 15.3877C0.0179882 15.7155 0.14945 16.029 0.38121 16.2608C0.61297 16.4925 0.926485 16.624 1.25423 16.6268C1.58198 16.6297 1.89773 16.5037 2.13348 16.276L9.20473 9.20473C9.43907 8.97032 9.57072 8.65244 9.57072 8.32098C9.57072 7.98953 9.43907 7.67164 9.20473 7.43723L2.13348 0.365983C1.89907 0.131644 1.58119 0 1.24973 0C0.918278 0 0.600393 0.131644 0.365983 0.365983Z"
          fill="#344F7A"
        />
      </svg>
    </Flex>
  );
};
export const DurationSelectionWithKit = withRouter(
  withSession(({ onContinue, session, history }) => {
    useEffect(() => {
      if (session && session.isGiMember) {
        history.push('/programs/gut-reset');
      }
    });
    const [isShowModal, setShowModal] = useState(false);
    return (
      <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
        <Header dark={false} mb={3} />
        <SuperContainer>
          <Container>
            <Text style={{ fontWeight: 500, fontSize: '18px' }} mb={3}>
              Which duration do you prefer?
            </Text>
            <Text style={{ fontWeight: 400, fontSize: '12px', opacity: 0.68 }} mb={3}>
              All our plans are paid upfront in full but we do have installment options
            </Text>

            <ButtonWith
              onClick={() => {
                onContinue(3);
              }}
              price={'212'}
              duration={'3'}
              description={'Quick reset'}
            />
            <ButtonWith
              onClick={() => {
                onContinue(6);
              }}
              price={'166'}
              duration={'6'}
              description={'Best results for most people'}
              isMostPopular
            />
            <ButtonWith
              onClick={() => {
                onContinue(9);
              }}
              price={'143'}
              duration={'9'}
              description={'Extended support for complex cases'}
            />

            <Text textAlign={'center'} style={{ color: '#44A5FF', fontSize: '14px', cursor: 'pointer' }} onClick={() => setShowModal(true)}>{`Not sure which option to pick? >`}</Text>
          </Container>
        </SuperContainer>
        {isShowModal && <LearnMoreModal learnMoreId={'gut-reset-durations'} onClose={() => setShowModal(false)} />}
      </FullLayout2>
    );
  })
);

export const DurationSelectionNoKit = withRouter(
  withSession(({ onContinue, session, history }) => {
    useEffect(() => {
      if (session && session.isGiMember) {
        history.push('/programs/gut-reset');
      }
    });
    const [isShowModal, setShowModal] = useState(false);
    return (
      <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
        <Header dark={false} mb={3} />
        <SuperContainer>
          <Container>
            <Text style={{ fontWeight: 500, fontSize: '18px' }} mb={3}>
              Which duration do you prefer?
            </Text>
            <Text style={{ fontWeight: 400, fontSize: '12px', opacity: 0.68 }} mb={3}>
              All our plans are paid upfront in full but we do have installment options
            </Text>

            <ButtonWith
              onClick={() => {
                onContinue(3);
              }}
              price={'130'}
              duration={'3'}
              description={'Quick reset'}
            />
            <ButtonWith
              onClick={() => {
                onContinue(6);
              }}
              price={'115'}
              duration={'6'}
              description={'Best results for most people'}
              isMostPopular
            />
            <ButtonWith
              onClick={() => {
                onContinue(9);
              }}
              price={'110'}
              duration={'9'}
              description={'Extended support for complex cases'}
            />

            <Text textAlign={'center'} style={{ color: '#44A5FF', fontSize: '14px', cursor: 'pointer' }} onClick={() => setShowModal(true)}>{`Not sure which option to pick? >`}</Text>
          </Container>
        </SuperContainer>
        {isShowModal && <LearnMoreModal learnMoreId={'gut-reset-durations'} onClose={() => setShowModal(false)} />}
      </FullLayout2>
    );
  })
);
